import React from 'react';
import './RouletteView.css';
import { RouletteService } from '../../../../../../../../shared/src/services/roulette.service';

export const RouletteView = ({ results }) => {
    if (!results) {
        return null;
    }

    let resultOutput = '';

    // in case results contains number pairs - group them in blocks
    if (results[0].includes('|')) {
        resultOutput = results.map((rouletteNumber, i) => {
            const rouletteNumbersPair = rouletteNumber.split('|');

            const colorClassTop = RouletteService.getRouletteResultColorClass(rouletteNumbersPair[0]);
            const colorClassBottom = RouletteService.getRouletteResultColorClass(rouletteNumbersPair[1]);
            return (
                <div key={i} className="roulette-result__block">
                    <div className={`roulette-result__item ${colorClassTop}`}>{rouletteNumbersPair[0]}</div>
                    <div className={`roulette-result__item ${colorClassBottom}`}>{rouletteNumbersPair[1]}</div>
                </div>
            );
        });
    } else {
        resultOutput = results.map((rouletteNumber, i) => {
            const colorClass = RouletteService.getRouletteResultColorClass(rouletteNumber);
            return <div key={i} className={`roulette-result__item ${colorClass}`}>{rouletteNumber}</div>;
        });
    }
    return (
        <div className="game-type__roulette roulette-result">{resultOutput}</div>
    );
};
